//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchUtils from '~/mixins/search/search-utils'

export default {
  name: 'SearchOtherBrands',
  mixins: [searchUtils],
  computed: {
    getBrands () {
      return this.getBrandsFromPage || this.searchFilters?.brands
    },
    hasBrands () {
      return !!this.getBrands?.length
    },
    getBrandsFromPage () {
      return this.$store.state.page.brands.filter(t => t.slug !== this.$route.params.slug).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
    }
  }
}
